import React from "react";
import PricingSection from "../components/pricing";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function PricingPage() {
  return (
    <>
      <Navbar />
      <PricingSection />
      <Footer />
    </>
  );
}

export default PricingPage;
